import React from "react";
import useAuth from "../hooks/useAuth";
import { Redirect, Route } from "react-router-dom";
import CommonLoader from "../components/ReusableComponents/CommonLoader/CommonLoader";

const AdminRoute = ({ children, ...rest }) => {
  const { isAdmin, isUserDataLoading } = useAuth();
  if (isUserDataLoading) {
    return <CommonLoader color="black" height="100vh" />;
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAdmin ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/redirect-to-no-access-path",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default AdminRoute;
